import React from "react";
import { Lock } from "lucide-react";
import { AppBadge } from "../ui";
import { ACCESS_COPY } from "./contentAccess";

/**
 * AccessBadge — "View only" / "View only · No copy" on a file.
 *
 * `access` is the block the server sends with every material and lesson. Staff
 * see the level their students get, so an admin list shows which files are
 * locked; a downloadable file carries no badge at all.
 */
export default function AccessBadge({ access, size = "sm", className = "" }) {
  const text = ACCESS_COPY[access?.level]?.badge;
  if (!text) return null;
  return (
    <AppBadge
      variant="secondary"
      size={size}
      className={className}
      title={access.enforced ? "Applied to every file by your institute's content protection setting" : undefined}
    >
      <Lock size={11} aria-hidden="true" />
      {text}
    </AppBadge>
  );
}
